import React, { useEffect, useState } from "react";
// import Certficates from './Certficates';
import Select from "react-select";
import Personal from "./Personal";
import Academic from "./Academic";
import Special from "./Special";
import CvStatus from "./CvStatus";
import axios from "axios";
import AdminCertUpload from "../../Admin/Services/Application/AdminCertUpload";
import { serverUrl } from "../../Constant/Static/config";

function Window({ userInfo }) {
  const [certificates, setCertificates] = useState([]);
  const [photoPreview, setPhotoPreview] = useState("");
  const [signaturePreview, setSignaturePreview] = useState("");
  const [students, setStudents] = useState([]);
  const [studentData, setStudentData] = useState(null);
  const [selectedCandidate, setSelectedCandidate] = useState("");
  const [currentSection, setCurrentSection] = useState(1);
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("A"); // 'V', 'N', 'P'
  // const [selectedCandidate, setSelectedCandidate] = useState(null);
  const [completed, setCompleted] = useState(false);

  const fileNameMap = {
    TENTH_MARKSHEET: "10th MarkSheet",
    TWELFTH_MARKSHEET: "12th MarkSheet",
    COMMUNITY_CERT: "Community certificate",
    SEM1: "1st Semester Marksheet",
    SEM2: "2nd Semester Marksheet",
    SEM3: "3rd Semester Marksheet",
    SEM4: "4th Semester Marksheet",
    SEM5: "5th Semester Marksheet",
    SEM6: "6th Semester Marksheet",
    SEM7: "7th Semester Marksheet",
    SEM8: "8th Semester Marksheet",
    CONSOLIDATE_MARKSHEET: "Consolidate Marksheet",
    PROVISIONAL_DEGREE_CERT: "Provisional Certificate",
    TRANSFER_CERT: "Transfer Certificate",
    NATIVE_CERT: "Nativity Certificate",
    AADHAR: "Aadhar Card",
    DA_CERT_1: "Disability Certificate 1",
    DA_CERT_2: "Disability Certificate 2",
    DA_CERT_3: "Disability Certificate 3",
    SPORT_CERT_1: "Sports Certificate 1",
    SPORT_CERT_2: "Sports Certificate 2",
    SPORT_CERT_3: "Sports Certificate 3",
    SPORT_CERT_4: "Sports Certificate 4",
    SPORT_CERT_5: "Sports Certificate 5",
    SPORT_CERT_6: "Sports Certificate 6",
    EX_SERVICE_CERT_1: "Ex-Serviceman Certificate 1",
    EX_SERVICE_CERT_2: "Ex-Serviceman Certificate 2",
    EX_SERVICE_CERT_3: "Ex-Serviceman Certificate 3",
    FG_CERT: "First Graduate Certificate",
  };

  const handleCertificateClick = (link) => {
    setSelectedCertificate(link);
  };

  const handleNext = () => {
    // console.log("currentSection", currentSection);

    setCurrentSection(currentSection + 1);
  };

  const handlePrevious = () => {
    setCurrentSection(currentSection - 1);
  };

  const handleLast = () => {
    setCurrentSection(4);
  }

  const fetchStudents = async () => {
    // console.log("User Info:", userInfo);
    try {
      const response = await axios.post(
        `${serverUrl}/api/cv/verifier/students`,
        {
          user_id: userInfo?.verifier_id,
          mobile: userInfo?.MOBILE,
        }
      );
      // console.log("Students:", response.data.students);
      // setStudents(response.data.students);
      if (Array.isArray(response.data.students)) {
        // console.log("Fetched students array:", response.data.students);
        setStudents(response.data.students); // Set the fetched data to the state
      } else {
        console.error("Expected an array but got:", response.data.students);
      }
      // console.log("Students:", students);
    } catch (error) {
      console.error("Error fetching students:", error);
    }
  };

  const fetchCertificates = async (APPLN_NO) => {
    // console.log("Application No:", APPLN_NO);
    try {
      const response = await axios.post(
        `${serverUrl}/api/cv/verifier/fetchCertificates`,
        {
          appno: APPLN_NO,
        }
      );
      // console.log(response.data);
      const { studentData, ImageData, uploadedPath } = response.data;

      // console.log("Student Data:", studentData);
      setStudentData(studentData || null);

      // console.log("Image Data:", ImageData);
      setPhotoPreview(ImageData?.photoUrl || "");
      setSignaturePreview(ImageData?.signatureUrl || "");

      // console.log("Certificates:", uploadedPath);
      setCertificates(uploadedPath.message ? [] : uploadedPath);
    } catch (error) {
      console.error("Error fetching certificates:", error);
    }
  };

  const fetchImages = async (APPLN_NO) => {
    // console.log("Application No:", APPLN_NO);
    try {
      const response = await axios.post(
        `${serverUrl}/api/cv/verifier/fetchImages`,
        {
          appno: APPLN_NO,
        }
      );
      
      const { studentData, ImageData } = response.data;
      // console.log("Student Data:", studentData);
      setStudentData(studentData || null);
      // console.log("Image Data:", ImageData);
      setPhotoPreview(ImageData?.photoUrl || "");
      setSignaturePreview(ImageData?.signatureUrl || "");
    } catch (error) {
      console.error("Error fetching Images:", error);
    }
  };
  const handleCompletedChange = async (e) => {
    const checked = e.target.checked;

    setCompleted(checked);

    try {
      await axios.post(
        `${serverUrl}/api/cv/verifier/completed`,
        {
          applnNo: selectedCandidate.APPLN_NO,
          verifierId: userInfo?.verifier_id,
          completed: checked,
        }
      );
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    fetchStudents();
  }, []);

  useEffect(() => {
    // console.log(studentData);

    // console.log("status", selectedStatus);
    if (selectedCandidate) {
      if (
        selectedCandidate.STATUS === "P" ||
        selectedCandidate.STATUS === "W" || userInfo?.verifier_id == "26001"
      ) {
        // console.log("Selected Candidate:", selectedCandidate);
        fetchCertificates(selectedCandidate.APPLN_NO);
        // fetchCompletedStatus(selectedCandidate.APPLN_NO);
      } else if (selectedCandidate) {
        fetchImages(selectedCandidate.APPLN_NO);
      }
    }
  }, [selectedCandidate]);

  let filteredStudents;
  // console.log(students);
  if (selectedStatus === "A") {
    filteredStudents = students;
  } else {
    filteredStudents = selectedStatus
      ? students.filter((student) => student.STATUS === selectedStatus)
      : students;

    if (selectedStatus == "W") {
      filteredStudents = filteredStudents.sort((a, b) => {
        // First, sort by uploadcheck (descending)
        if (b.uploadcheck !== a.uploadcheck) {
          return b.uploadcheck - a.uploadcheck;
        }
        // If uploadcheck is same, sort by APPLN_NO (ascending as number)
        return parseInt(a.APPLN_NO) - parseInt(b.APPLN_NO);
      });
    }
  }
  // const fetchCompletedStatus = async (applnNo) => {
  //   try {
  //     const res = await axios.post(
  //       `${serverUrl}/api/cv/verifier/completedStatus`,
  //       {
  //         applnNo,
  //         verifierId: userInfo?.verifier_id,
  //       }
  //     );

  //     setCompleted(res.data.completed);
  //   } catch (err) {
  //     console.error(err);
  //   }
  // };
  const studentOptions = filteredStudents.map((student) => {
    let backgroundColor = "white";
    let textColor = "black";

    if ((student.STATUS === "P" || student.STATUS === "W" )&& student.completed) {
      backgroundColor = "red";
    }
    else if (student.STATUS === "P" && student.viewed == 1) {
      backgroundColor = "#FFD700";
    }
    else if (student.uploadcheck == 1) {
      backgroundColor = "lightgreen";
    }


    return {
      value: student.APPLN_NO,
      label: `${student.APPLN_NO} - ${student.applicant_name}`,
      STATUS: student.STATUS,
      colorCondition: textColor,
      backgroundColorCondition: backgroundColor,
    };
  });
  // console.log(studentOptions);
  const customStyles = {
    menu: (provided) => ({
      ...provided,
      width: "300px",
      overflowX: "hidden",
    }),
    control: (provided) => ({
      ...provided,
      width: "300px",
      padding: 0,
    }),
    menuList: (provided) => ({
      ...provided,
      overflowX: "hidden", // ⛔ Prevent horizontal scroll inside list
    }),
    option: (base, state) => ({
      ...base,
      color: state.data.colorCondition,
      backgroundColor: state.data.backgroundColorCondition
    }),
  };

  const handleCandidateChange = async (event) => {
    const selectedApplnNo = event.target.value;
    let result = students.find((student) => {
      return student.APPLN_NO == selectedApplnNo
    })
    if(result.completed === 1){
      setCompleted(true);
    }
    else {
      setCompleted(false);
    }
    try {
      await axios.post(
        `${serverUrl}/api/cv/verifier/markViewed`,
        {
          verifierId: userInfo?.verifier_id,
          applnNo: selectedApplnNo,
        }
      );
    } catch (err) {
      console.error("Error marking viewed:", err);
    }

    const candidate = students.find(
      (student) => student.APPLN_NO === selectedApplnNo
    );

    if (candidate !== selectedCandidate) {
      setStudentData(null);
      setCertificates([]);
      setPhotoPreview("");
      setSignaturePreview("");
      setSelectedCertificate(null);
      setCurrentSection(1);

      setSelectedCandidate(candidate);
    }
  };
  const handleStatusFilter = (status) => {
    // console.log("selectedstatus", selectedStatus);

    const filteredStudents = selectedStatus
      ? students.filter((student) => student.STATUS === selectedStatus)
      : students;
    setSelectedStatus(status);
    setSelectedCandidate(null);
    setStudentData(null);
  };

  const handleUpdateStatus = () => {
    setSelectedCandidate(null);
    setStudentData(null);
    setCertificates([]);
    setPhotoPreview("");
    setSignaturePreview("");
    setSelectedCertificate(null);
    setCurrentSection(1);
    fetchStudents();
  };

  return (
    <div className="cv_student_profile" style={{ margin: "20px" }}>
      <div className="button-container">
        <button
          onClick={() => handleStatusFilter("A")}
          className={`status-button ${selectedStatus === "A" ? "active" : ""}`}
        >
          ALL
        </button>
        <button
          onClick={() => handleStatusFilter("V")}
          className={`status-button ${selectedStatus === "V" ? "active" : ""}`}
        >
          VERIFIED
        </button>

        <button
          onClick={() => handleStatusFilter("P")}
          className={`status-button ${selectedStatus === "P" ? "active" : ""}`}
        >
          PENDING
        </button>

        <button
          onClick={() => handleStatusFilter("W")}
          className={`status-button ${selectedStatus === "W" ? "active" : ""}`}
        >
          WAITING LIST
        </button>

        <button
          onClick={() => handleStatusFilter("E")}
          className={`status-button ${selectedStatus === "E" ? "active" : ""}`}
        >
          NOT ELIGIBLE
        </button>
      </div>

      <section className="profile_section">
        <div className="profile_select">
          <div className="form-item">
            {/* <h4>{students.map(student => student.NAME).join(', ')}</h4> */}
            <h1 style={{ textAlign: "center", color: "#1C274C" }}>
              Verification Window
            </h1>

            {Array.isArray(students) && students.length > 0 ? (
              <div className="search-select-container">
                <Select
                  className="searchable-select"
                  classNamePrefix="searchable-select"
                  options={studentOptions}
                  onChange={(selected) =>
                    handleCandidateChange({ target: { value: selected.value } })
                  }
                  value={
                    studentOptions.find(
                      (option) => option.value === selectedCandidate?.APPLN_NO
                    ) || null
                  }
                  styles={customStyles}
                  placeholder="--- Select Student ---"
                />
              </div>
            ) : (
              <p>No students available.</p>
            )}
          </div>
          {studentData && (
            <div className="profile_info">
              <div>
                <h4>Application No: {studentData.APPLN_NO}</h4>
                <h4>Applicant Name: {studentData.APPLICANT_NAME}</h4>
              </div>
              <div>
                <h4>Mobile: {studentData.MOBILE}</h4>
                <h4>Email: {studentData.EMAIL}</h4>
              </div>
              {students.status}
            </div>
          )}
        </div>
        {selectedCandidate && (
          <div className="profile_img">
            <div className="img-container">
              <img src={photoPreview} alt="" width={120} height={120} />
            </div>
            <div className="img-container">
              <img src={signaturePreview} alt="" width={120} height={40} />
            </div>
            {(userInfo?.verifier_id == "26001" || 
              userInfo?.verifier_id == "26005" ||
              userInfo?.verifier_id == "26013" ||
              userInfo?.verifier_id == "26015" ||
              userInfo?.verifier_id == "26016"
            )&& 
            <div
              style={{
                marginTop: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <input
                type="checkbox"
                id="completed"
                checked={completed}
                onChange={handleCompletedChange}
              />
              <label
                htmlFor="completed"
                style={{
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                Completed
              </label>
            </div>}
          </div>
        )}
      </section>
      {selectedCandidate &&
        (selectedCandidate.STATUS === "E" ||
          selectedCandidate.STATUS === "W") && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "10px",
            }}
          >
            <table
              style={{
                borderCollapse: "collapse",
                width: "100%",
                maxWidth: "800px",
              }}
            >
              <tr style={{ height: "10px", backgroundColor: "rgb(94 148 221)", color: '#fff' }}>
                <td
                  style={{
                    border: "1px solid #000",
                    textAlign: "center"
                  }}
                >
                  <h3>COMMENT</h3>
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    padding: "8px",
                    paddingLeft: "10px",
                    width: "90%",
                    border: "1px solid #000",
                    textAlign: "center"
                  }}
                >
                  <h4>{selectedCandidate.COMMENT}</h4>
                </td>
              </tr>
            </table>
          </div>
        )}

      {userInfo?.verifier_id == "26001" && selectedCandidate && (
        <div style={{ marginLeft: "300px" }}>
          <h2
            style={{
              color:
                selectedCandidate.STATUS === "E"
                  ? "#ea0100"
                  : selectedCandidate.STATUS === "V"
                    ? "#4bb543"
                    : "black",
            }}
          >
            Student Status :{" "}
            {selectedCandidate.STATUS === "E"
              ? "Not Eligible"
              : selectedCandidate.STATUS === "V"
                ? "Verified"
                : ""}
          </h2>
        </div>
      )}

      {/* {selectedCandidate &&
        ( selectedCandidate.STATUS != "P" &&
          selectedCandidate.STATUS != "W") &&
        <section>
          <div className="certificate-section">
            <h3 style={{ color: "#1C274C" }}>Certificates</h3>
            <table>
              <thead style={{ backgroundColor: "#f2f2f2" }}>
                <tr>
                  <th style={{ textAlign: "center", fontSize: "16px" }}>
                    Certificate Name
                  </th>
                  <th style={{ textAlign: "center", fontSize: "16px" }}>
                    Certificate View
                  </th>
                </tr>
              </thead>
              <tbody>
                {certificates && Object.keys(certificates).length > 0 ? (
                  Object.keys(certificates).map((key, index) => (
                    <tr key={index}>
                      <td style={{ fontSize: "15px", fontWeight: "500" }}>
                        {fileNameMap[key]}
                      </td>
                      <td>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-evenly",
                            alignItems: "center",
                          }}
                        >
                          <button
                            onClick={() =>
                              handleCertificateClick(certificates[key])
                            }
                          >
                            View Certificate
                          </button>
                          <button
                            onClick={() =>
                              window.open(certificates[key], "_blank")
                            }
                          >
                            Open in New Tab
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="2"
                      style={{ textAlign: "center", color: "#d00000" }}
                    >
                      No certificates available
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </section>

      } */}

      {selectedCandidate &&
        (userInfo?.verifier_id == "26001" ||

          selectedCandidate.STATUS === "P" ||
          selectedCandidate.STATUS === "W") ? (
        <>
          <section>
            <div className="certificate-section">
              <h3 style={{ color: "#1C274C" }}>Certificates</h3>
              <table>
                <thead style={{ backgroundColor: "#f2f2f2" }}>
                  <tr>
                    <th style={{ textAlign: "center", fontSize: "16px" }}>
                      Certificate Name
                    </th>
                    <th style={{ textAlign: "center", fontSize: "16px" }}>
                      Certificate View
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {certificates && Object.keys(certificates).length > 0 ? (
                    Object.keys(certificates).map((key, index) => (
                      <tr key={index}>
                        <td style={{ fontSize: "15px", fontWeight: "500" }}>
                          {fileNameMap[key]}
                        </td>
                        <td>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-evenly",
                              alignItems: "center",
                            }}
                          >
                            <button
                              onClick={() =>
                                handleCertificateClick(certificates[key])
                              }
                            >
                              View Certificate
                            </button>
                            <button
                              onClick={() =>
                                window.open(certificates[key], "_blank")
                              }
                            >
                              Open in New Tab
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="2"
                        style={{ textAlign: "center", color: "#d00000" }}
                      >
                        No certificates available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </section>
          <h3 style={{ color: "#1C274C" }}>Student Information</h3>
          <section
            style={{
              alignItems: "center",
              border: "1px solid #ccc",
              margin: "20px 0",
            }}
          >
            {currentSection === 1 && (
              <Personal studentData={studentData} handleNext={handleNext} gotoComment={handleLast} />
            )}
            {currentSection === 2 && (
              <Academic
                studentData={studentData}
                handlePrev={handlePrevious}
                handleNext={handleNext}
                gotoComment={handleLast}
              />
            )}
            {currentSection === 3 && (
              <Special
                studentData={studentData}
                handlePrev={handlePrevious}
                handleNext={handleNext}
              />
            )}
            {currentSection === 4 && (
              <CvStatus
                studentData={studentData}
                handlePrev={handlePrevious}
                handleNext={handleNext}
              />
            )}
            {currentSection === 5 && handleUpdateStatus()}
          </section>
          {/* <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', border: '1px solid #ccc', margin: '20px 0' }}>
              <h4 style={{ color: '#d00000' }}>Student Data Not Found</h4>
            </section> */}
          {/* <section style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', border: '1px solid #ccc', margin: '20px 0' }}>
            {currentSection === 1 && (
              <Personal studentData={studentData} handleNext={handleNext} />
            )}
            {currentSection === 2 && (
              <Academic studentData={studentData} handlePrev={handlePrevious} handleNext={handleNext} />
            )}
            {currentSection === 3 && (
              <Special studentData={studentData} handlePrev={handlePrevious} />
            )}
          </section> */}
          {/* <section className='ifram-section'>
            {selectedCertificate && (
              <div className="iframe-container">
                <h3>Certificate Viewer</h3>
                <iframe
                  src={selectedCertificate}
                  title="Certificate"
                  width="600"
                  height="400"
                  className="certificate-iframe"
                ></iframe>
              </div>
            )}
          </section> */}

          {/* POP-up for view certificate  */}
          {selectedCertificate && (
            <div className="popup-certificate">
              <div className="modal">
                <div className="heading">
                  <h3 >Quick Certificate Preview</h3>
                  <button
                    className="popup-close"
                    onClick={() => setSelectedCertificate(null)}
                  >
                    &times;
                  </button>
                </div>
                <div className="modal-body">
                  <iframe
                    src={selectedCertificate}
                    title="Certificate"
                    className="dimension"
                  ></iframe>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        selectedCandidate && (
          <div style={{ marginLeft: "300px" }}>
            <h2
              style={{
                color:
                  selectedCandidate.STATUS === "E"
                    ? "#ea0100"
                    : selectedCandidate.STATUS === "V"
                      ? "#4bb543"
                      : "black",
              }}
            >
              Student Status :{" "}
              {selectedCandidate.STATUS === "E"
                ? "Not Eligible"
                : selectedCandidate.STATUS === "V"
                  ? "Verified"
                  : ""}
            </h2>
          </div>
        )




        // <div>
        //   <h2>Student Status : verified</h2>
        // </div>
      )}

      {
        (selectedCandidate && studentData && userInfo?.verifier_id == '26001') && (
          <AdminCertUpload userInfo={studentData} />
        )
      }
    </div>
  );
}

export default Window;